exports.f = require('./_wks');


//////////////////
// WEBPACK FOOTER
// /app/node_modules/core-js/library/modules/_wks-ext.js
// module id = 342
// module chunks = 0